import React from 'react';

import Badge from '../Badge';

const formatDate = (d) =>
  d.toLocaleString(window.navigator.language, {
    month: 'short',
    day: 'numeric',
  });

const DateFieldBadge = ({ field, item }) => {
  if (!item || !item.value || !item.value.date) {
    return null;
  }
  const formatted = formatDate(new Date(item.value.date));

  return (
    <Badge>
      <span>{`${field.name}: ${formatted}`}</span>
    </Badge>
  );
};

export default DateFieldBadge;



// WEBPACK FOOTER //
// ./app/common/components/canonical-components/canonical-card/badges/DateFieldBadge.js